import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Collections from "../components/Collections";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Collections);
const withTranslationComponent = withTranslation(["collections", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/Collections.js